export function validateUsername(value: string) {
	const val = value.trim();
	const match = /^[a-zA-Z0-9.]*$/;

	if (val?.length > 0 && val?.length <= 128) {
		return match.test(val);
	}

	return false;
}

export function validateFirstName(value: string) {
	const val = value.trim();
	const match = /^[a-zA-Z ]*$/;

	if (val?.length > 0 && val?.length <= 30) {
		return match.test(val);
	}

	return false;
}

export function validateUserID(value: string) {
	const val = value.trim();
	const match = /^[a-zA-Z0-9]{32}$/;

	if (val?.length === 32) {
		return match.test(val);
	}

	return false;
}

export function validateLastName(value: string) {
	return validateFirstName(value);
}

export function validateEmail(value: string) {
	const val = value.trim();
	const match = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+\.[a-zA-Z]+(?:\.[a-zA-Z0-9-]+)*$/;

	if (val?.length > 0 && val?.length <= 254) {
		return match.test(val);
	}

	return false;
}

export function validateTenantCode(value: string) {
	const val = value.trim();

	if (val?.length > 0 && val?.length <= 10) {
		return true;
	}

	return false;
}

export function validateGroupName(value: string) {
	const val = value.trim();
	const match = /^\w*$/;

	if (val?.length > 0 && val?.length <= 30) {
		return match.test(val);
	}

	return false;
}

export function validateGroupDescription(value: string) {
	const val = value.trim();
	const match = /^[a-zA-Z0-9 _,.]*$/;

	if (val?.length > 0 && val?.length <= 200) {
		return match.test(val);
	}

	return false;
}

export function validateClaimReceiptNumber(value: string) {
	const val = value.trim();
	const match = /^[a-zA-Z0-9-]*$/;

	if (val?.length && val?.length <= 50) {
		return match.test(val);
	}

	return false;
}

export function validateCardNumber(value: string) {
	const val = value.trim();
	const match = /^\d*$/;

	if (val?.length >= 19) {
		return match.test(val);
	}

	return false;
}

export function validateAmount(value: string) {
	const val = value.trim();
	const match = /^\d{0,10}(\.\d{1,2})?$/;

	if (val?.length > 0) {
		return match.test(val);
	}

	return false;
}

export function validateReimbursementRejectReason(value: string) {
	const val = value.trim();
	const match = /^[a-zA-Z0-9 ,.$]*$/;

	if (val?.length && val?.length <= 1000) {
		return match.test(val);
	}

	return false;
}

export function validateRejectRetroClaimReason(value: string) {
	const val = value.trim();
	const match = /^[a-zA-Z0-9 ,.$+=-]*$/;

	if (val?.length && val?.length <= 1000) {
		return match.test(val);
	}

	return false;
}
